import { ECasinoGameMode, ECasinoGameViewOrder } from 'interfaces/casino-data';
import { UtilsCasino } from './index';

export interface IGameInfo {
  id: string;
  mode: ECasinoGameMode;
  order: ECasinoGameViewOrder;
}

export const extractGameInfoFromSearchParams = (
  searchParams: Record<string, string | undefined>
) => {
  const paramsTuples = Object.entries(searchParams);

  return paramsTuples.reduce((acc, [key, value]) => {
    if (
      value &&
      [ECasinoGameMode.REAL, ECasinoGameMode.FUN].includes(
        value as ECasinoGameMode
      )
    ) {
      const { order, gameId } = UtilsCasino.decodeGameIdWithPrefix(key);

      if (!Number.isNaN(order) && !Number.isNaN(gameId)) {
        acc.push({
          id: `${gameId}`,
          mode: value as ECasinoGameMode,
          order: order
        });
      }
    }

    return acc;
  }, [] as IGameInfo[]);
};
